module.exports = __webpack_public_path__ + "img/scene2-6.c4ca169d.jpg";